import React, { memo } from 'react';
import { StyledMiniBasketItem } from '../styled';
import { LineItemViewModel } from '~/lib/data-contract';
import { Text, PriceGroup, Image } from '~/shared/components';
import { useTranslation } from '~/shared/utils/translation';
import { SkeletonLegacy } from '~/shared/components/SkeletonLegacy';

type Props = LineItemViewModel;

export const MiniBasketItem = memo((props: Props) => {
    const { name, imageUrl, color = '', size = '', quantity, priceDetails } = props;

    const { translate } = useTranslation();
    const separator = color && size ? ' - ' : '';

    return (
        <StyledMiniBasketItem
            layout
            initial={{ opacity: 0 }}
            animate={{
                opacity: 1,
                scale: 1,
            }}
        >
            {Object.keys(props).length ? (
                <>
                    {imageUrl ? (
                        <Image
                            src={imageUrl}
                            alt={name ?? ''}
                            height={79}
                            width={65}
                            sizes="86px"
                            style={{ objectFit: 'contain' }}
                        />
                    ) : (
                        <SkeletonLegacy height={75} width={86} />
                    )}
                    <div>
                        <Text variant="bodySm" children={name} />
                        <Text variant="caption" children={`${color}${separator}${size}`} />
                        <Text
                            variant="caption"
                            children={translate('minibasket.lineQuantity', {
                                quantity: (quantity || 1)?.toString(),
                            })}
                        />
                        <PriceGroup {...priceDetails} variant="bodySm" />
                    </div>
                </>
            ) : (
                <>
                    <SkeletonLegacy height={75} width={86} shimmer />
                    <SkeletonLegacy style={{ width: '1fr', height: '100%' }} shimmer />
                </>
            )}
        </StyledMiniBasketItem>
    );
});
